import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const CREATED_AT_OPTION_VALUE = '';

type Props = {
	readonly sortableFields: readonly SubjectFieldDefinitionView[];
	readonly withLabel?: boolean;
};

/** Picks what the list is sorted by: the creation date, or one of the sortable sheet fields. */
const SortFieldFilter: React.FC<Props> = ({ sortableFields, withLabel = false }) => {
	const currentFilters = useSignalValue(subjectFiltersSignal);

	const options = React.useMemo(
		() => [
			{ label: 'Date de création', value: CREATED_AT_OPTION_VALUE },
			...sortableFields.map((field) => ({ label: field.label, value: field.key })),
		],
		[sortableFields],
	);

	const handleChange = React.useCallback((value: string | null) => {
		const key = value === null || value === CREATED_AT_OPTION_VALUE ? null : value;

		setSubjectFilters(subjectFiltersSignal.peek().setSortKey(key));
	}, []);

	return (
		<Dropdown<string>
			name="subjectSortField"
			label="Trier par"
			isLabelHidden={!withLabel}
			placeholder="Trier par"
			options={options}
			optionLabel="label"
			optionValue="value"
			value={currentFilters.fieldSort?.key ?? CREATED_AT_OPTION_VALUE}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default SortFieldFilter;
